/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Keyword_OneInputs */

const en_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} keyword`)
};

const zh_hans1_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个关键词`)
};

const pt_br2_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} palavra-chave`)
};

const es_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} palabra clave`)
};

const fr_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mot-clé`)
};

const de_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Keyword`)
};

const ru_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ключевое слово`)
};

const it_measure_unit_keyword_one = /** @type {(inputs: Measure_Unit_Keyword_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} parola chiave`)
};

/**
* | output |
* | --- |
* | "{count} keyword" |
*
* @param {Measure_Unit_Keyword_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_keyword_one = /** @type {((inputs: Measure_Unit_Keyword_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Keyword_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_keyword_one(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_keyword_one(inputs)
	if (locale === "es") return es_measure_unit_keyword_one(inputs)
	if (locale === "fr") return fr_measure_unit_keyword_one(inputs)
	if (locale === "de") return de_measure_unit_keyword_one(inputs)
	if (locale === "ru") return ru_measure_unit_keyword_one(inputs)
	if (locale === "it") return it_measure_unit_keyword_one(inputs)
	return en_measure_unit_keyword_one(inputs)
});